import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { updateAssignedWorksheets } from "../../assignedWorksheetListSlice";

import Modal from "../../../../components/Modal";
import DateSelectionPage from "../WorksheetModal/DateSelectionPage/DateSelectionPage";

const DateUpdateModal = ({ worksheet, onClose }) => {
  const dispatch = useDispatch();

  const [hideAfterClosed, setHideAfterClosed] = useState(
    worksheet.hide_after_closed
  );
  const [selectedDate, setSelectedDate] = useState(
    new Date(worksheet.closed_at)
  );

  const handleSubmit = async () => {
    const data = {
      closed_at: selectedDate,
      hide_after_closed: hideAfterClosed,
    };
    dispatch(
      updateAssignedWorksheets({
        worksheetId: worksheet.id,
        data: data,
      })
    );
    alert("과제의 마감일이 변경되었습니다.");
    onClose();
  };

  return (
    <Modal>
      <DateSelectionPage
        selectedDate={selectedDate}
        handleDateSelect={setSelectedDate}
        hideAfterClosed={hideAfterClosed}
        setHideAfterClosed={setHideAfterClosed}
        onClose={onClose}
        onClickNext={handleSubmit}
      />
    </Modal>
  );
};

export default DateUpdateModal;
